import request from '@/http/request';

// 获取员工列表
export function getEmployeeList(params) {
  return request({
    url: '/api/v1/ops/employee_list',
    method: 'get',
    params,
  });
}

// 创建员工信息
export function createEmployee(data) {
  return request({
    url: '/api/v1/ops/employee_create',
    method: 'post',
    data,
  });
}

// 更新员工信息
export function updateEmployee(employeeId, data) {
  return request({
    url: `/api/v1/ops/employee_update/${employeeId}`,
    method: 'put',
    data,
  });
}

// 删除员工信息
export function deleteEmployee(employeeId) {
  return request({
    url: `/api/v1/ops/employee_delete/${employeeId}`,
    method: 'delete',
  });
}

// 根据员工ID查询操作日志
export function getEmployeeHistory(employeeId) {
  return request({
    url: `/api/v1/ops/employee_logs/${employeeId}`,
    method: 'get',
  });
}

// 根据员工ID获取详情
export function getEmployeeDetail(employeeId) {
  return request({
    url: `/api/v1/ops/employee/${employeeId}`,
    method: 'get',
  });
}